module.exports = __webpack_public_path__ + "static/media/icon-congrats.e343f10a.png";